// extracted by mini-css-extract-plugin
module.exports = {"registerDialog":"SetDialog_registerDialog__2XrYQ","buttons":"SetDialog_buttons__2PPkB","MuiInputBase-input":"SetDialog_MuiInputBase-input__2O886"};